module.exports = __webpack_public_path__ + "img/navbar.e9a92320.png";